import { useQuery } from '@tanstack/react-query';
import {
  GetInternshipOffers,
  GetStudentApplications,
} from '../helper/apiHelper';
import { QUERY_KEYS } from '../Constants/queryKeys';
import { useHasRole } from './useHasRole';
import { Roles } from '../Types/interfaces';

export const useInternshipOffers = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.INTERNSHIP_OFFERS],
    queryFn: GetInternshipOffers,
  });
};

export const useStudentApplications = (studentId: number) => {
  const hasRole = useHasRole();
  const isStudent = hasRole(Roles.Student);

  return useQuery({
    queryKey: [...QUERY_KEYS.STUDENT_APPLICATIONS, studentId],
    queryFn: () => GetStudentApplications(studentId),
    enabled: !!studentId && isStudent,
  });
};
